module.exports = __webpack_public_path__ + "assets/webgl/card_verso_L0.jpg.0c0afbe9.webp";